import React from 'react';
import Search from './components/search/Search';
import NavBar from './components/navbar/NavBar';
// import './App.css';
import logo from './logo.png'
import { Divider } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ReplyIcon from '@material-ui/icons/Reply';
const App5 =()=> {
    return (
      <div>
      <Link to={'/'} className="p-3">
						<ReplyIcon className="pb-2" style={{ fontSize: 'x-large', cursor: 'pointer' }} />{' '}
						<span style={{ fontSize: 'large' }}>Back</span>
					</Link>
        <div className="text-center">
          {/* <NavBar /> */}
          <h4 className="d-inline align-bottom">Powered By </h4><img className="d-inline mt-5" src={logo} style={{width:'200px'}}/>
          <Search />
        </div>
        </div>
    );
  }


export default App5;
